/* global App */

(function () {
    var currencyMap = {
        "CZK":{
            "CZK":1,
            "EUR":0.03
        },
        "EUR":{
            "CZK":27,
            "EUR":1
        }
    };
    var currencyString = {
        "CZK":"Kč",
        "EUR":"€"
    };
    var decimal = {
        "CZK":2,
        "EUR":4
    };
    App.Currency = {
       format: function (value,originalCurrency,viewCurrency,viewUnit) {
           originalCurrency = originalCurrency || 'CZK';
           viewCurrency = viewCurrency || 'CZK';
           viewUnit = viewUnit || 'CZK';

           var convertValue = value*currencyMap[originalCurrency][viewCurrency];
           convertValue = Math.round(convertValue*Math.pow(10,decimal[viewCurrency]))/Math.pow(10,(decimal[viewCurrency]));
           var result = convertValue;
           if(viewUnit)result = result+" "+currencyString[viewCurrency];
           return result;
       },
       convert: function (value,originalCurrency,viewCurrency) {
           originalCurrency = originalCurrency || 'CZK';
           viewCurrency = viewCurrency || 'CZK';
           var convertValue = value*currencyMap[originalCurrency][viewCurrency];
           convertValue = Math.round(convertValue*Math.pow(10,decimal[viewCurrency]))/Math.pow(10,(decimal[viewCurrency]));
           return convertValue;
       },
       unit: function (currency) {
           return currencyString[currency];
       }
    };
})();
